import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import PriceDisplay from "../../containers/PriceDisplay";
import styles from "./styles.less";
import Dotdotdot from "react-dotdotdot";
import { Arrow } from "../common";

/// ThumbnailText is a sub component of Thumbnail

class ThumbNailText extends React.Component {
  renderProductPrice = product => {
    const {
      titles,
      showClubPrices,
      isMobileView,
      showPricePerNightThumb
    } = this.props;
    const price = showClubPrices
      ? product.simpleClubLowestPrice
      : product.lowestPrice;
    return (
      <span>
        {titles.StartingFrom}
        <span
          className={cx(styles.price, { [styles.mobileView]: isMobileView })}
        >
          <PriceDisplay
            price={price}
            currentCurrencyCode={product.currencyCode}
            fallBackCurrencySymbol={product.currency}
            showPricePerNightThumb={showPricePerNightThumb}
          >
            {convertedPrice => convertedPrice}
          </PriceDisplay>
        </span>
      </span>
    );
  };

  renderProductData = product => {
    const {
      extendedType,
      titles,
      onMoreDetailsClick,
      renderMarkup,
      isMobileView,
      isRtl,
      onClick
    } = this.props;
    if (renderMarkup == null) {
      return (
        <div
          className={cx(styles.textAndBtnWrapper, {
            [styles.extendedType]: extendedType
          })}
        >
          <div className={styles.textWrapper}>
            <div className={styles.title}>
              <Dotdotdot clamp={1}>{product.name}</Dotdotdot>
            </div>
            {extendedType && (
              <div className={styles.descriptionWrapper}>
                <div
                  className={styles.readMore}
                  onClick={onMoreDetailsClick}
                  onKeyDown={onMoreDetailsClick}
                  role="button"
                  tabIndex="0"
                >
                  {titles.ReadMore}...
                </div>
              </div>
            )}
            <div
              className={cx(styles.priceWrapper, {
                [styles.priceText]: extendedType
              })}
            >
              {this.renderProductPrice(product)}
            </div>
          </div>
          {isMobileView && (
            <div
              className={cx(styles.btnWrapper, {
                [styles.rtl]: isRtl
              })}
            >
              <Arrow
                direction={isRtl ? Arrow.position.LEFT : Arrow.position.RIGHT}
                className={styles.btn}
              />
            </div>
          )}
        </div>
      );
    } else {
      return renderMarkup(product, onClick);
    }
  };

  render() {
    const { product } = this.props;

    return <div>{this.renderProductData(product)}</div>;
  }
}

ThumbNailText.defaultProps = {
  isMobileView: false
};

ThumbNailText.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  product: PropTypes.object,
  showClubPrices: PropTypes.bool,
  extendedType: PropTypes.bool,
  isMobileView: PropTypes.bool,
  onMoreDetailsClick: PropTypes.func,
  renderMarkup: PropTypes.func,
  onClick: PropTypes.func,
  showPricePerNightThumb: PropTypes.bool
};

export default ThumbNailText;



// WEBPACK FOOTER //
// ./src/components/ThumbNailText/ThumbNailText.js